import { render, staticRenderFns } from "./LanguageChooser.vue?vue&type=template&id=147f13ca&"
import script from "./LanguageChooser.vue?vue&type=script&lang=ts&"
export * from "./LanguageChooser.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageChooser.vue?vue&type=style&index=0&id=147f13ca&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports